<div class="flex justify-center items-center min-h-screen w-full">
    <div class="flex flex-col w-full max-w-full">
        <app-logo [logo]="logo" />
        <h1 class="text-center pt-8 mb-8 font-semibold sm:text-3xl text-2xl text-wrap">Service Agreement</h1>
        <div class="flex flex-col justify-center items-center gap-8 px-4">
            <p class="max-w-2xl text-center leading-relaxed">Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                Odio,
                illo incidunt, ipsam tempora eos nulla maxime, deserunt explicabo eum aut itaque? Fugiat temporibus
                ratione
                aperiam. Beatae numquam distinctio nostrum repellendus.</p>
            <app-agreement-btn (checkedChange)="onCheckedChange($event)" />
            <div [@slideIn] *ngIf="isChecked"
                class="w-full p-4 mt-4 flex justify-center items-center gap-4 hover:cursor-pointer"
                (click)="routeToTracking()">
                <div class="bounce-animation">
                    <lucide-icon class="" [img]="arrowRight" [color]="'black'" [size]="50"></lucide-icon>
                </div>
                <p class="font-semibold text-center text-wrap text-md underline text-cyan-600 hover:text-black">
                    {{captainText}}</p>
            </div>
        </div>
    </div>